import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** The `MultiSchemaFieldTemplate` component renders the layout for the MultiSchemaField, which supports choosing
 * a schema from a list of schemas defined using `anyOf` or `oneOf`.
 *
 * @param props - The `MultiSchemaFieldTemplate` to be rendered
 */
export default function MultiSchemaFieldTemplate(props) {
    const { selector, optionSchemaField } = props;
    return (_jsxs("div", { className: 'panel panel-default panel-body', children: [_jsx("div", { className: 'form-group', children: selector }), optionSchemaField] }));
}
